import { useIsWaitingForResponse } from '@verantos-dev/app-state-research-assistant';
import { useAuth } from '@verantos-dev/core-auth';

import { useAnalysisProfileQuery } from '../api/useAnalysisProfileQuery';
import type { UseAnalysisEditLockResult } from '../types';
import { useAnalysisRouteParams } from './useAnalysisRouteParams';

// Single edit-lock gate for the analysis definition. Editing is locked when the
// current user didn't create the analysis, its latest run is in flight, or the
// Research Assistant is working (it edits the same definition, so a concurrent
// manual edit would race it).
// Locked-until-known: while the profile is loading `isOwner` is false, so
// affordances stay disabled.
export const useAnalysisEditLock = (): UseAnalysisEditLockResult => {
  const {
    user: { auth0Id, userId },
  } = useAuth();
  const { projectId, analysisProfileId } = useAnalysisRouteParams();
  const { data } = useAnalysisProfileQuery({ projectId, analysisProfileId });
  const isWaitingForRA = useIsWaitingForResponse();
  const profile = data?.data;

  const isProcessing = profile?.latestStatus === 'PROCESSING';
  const ownerUserId = profile?.createdBy?.userId;
  const isOwner = !!ownerUserId && [auth0Id, userId].includes(ownerUserId);

  return {
    isEditDisabled: !isOwner || isProcessing || isWaitingForRA,
    isProcessing,
    isOwner,
    isWaitingForRA,
  };
};
